import "core-js/modules/es.array.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "checkall",
  style: {
    "padding-left": "24px"
  }
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("全选");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { getAreaTree, addCustomerArea } from '@/request';
import { ElMessage } from 'element-plus';
export default {
  name: 'SelectAreaTreeModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    defaultCheckedNodes: {
      type: Array,
      default: () => []
    },
    editData: {
      type: [null, Object],
      default: null
    },
    id: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const treeData = ref([]);
    const treeRef = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const filterText = ref('');
    watch(filterText, val => {
      var _treeRef$value;

      (_treeRef$value = treeRef.value) === null || _treeRef$value === void 0 ? void 0 : _treeRef$value.filter(val);
    });

    function filterNode(value, data) {
      if (!value) return true;
      return data.text.includes(value);
    }

    getAreaTree().then(data => {
      if (data !== null && data !== void 0 && data.length) {
        treeData.value = data;
        flattenTreeIdList.value = flattenTreeData(data);
      }
    });

    function confirm() {
      let selectDatas = treeRef.value.getCheckedNodes();
      emit('success', selectDatas);
      visible.value = false; // addCustomerArea({
      //   areaCodes: selectDatas.map((item) => item.id).join(','),
      //   activityId: props.id,
      //   moduleType: 20,
      //   readFromBackup: 1,
      //   __repeat: true,
      //   __warn: true
      // }).then((data) => {
      //   if (data.success) {
      //     ElMessage.success('操作成功!');
      //     visible.value = false;
      //     emit('success', selectDatas);
      //   }
      // });
    } // 全选反选


    const checkAll = ref(false);
    const flattenTreeIdList = ref([]);
    watch(visible, v => {
      if (!v) return; // 设置全选反选状态

      if (props.defaultCheckedNodes.length > 0 && flattenTreeIdList.value.length === props.defaultCheckedNodes.length) {
        checkAll.value = true;
      } else {
        checkAll.value = false;
      }
    });

    function checkAllHandle(value) {
      if (value) {
        treeRef.value.setCheckedKeys(flattenTreeIdList.value);
      } else {
        treeRef.value.setCheckedKeys([]);
      }
    }

    function treeCheckHandle(current, treeCheckObj) {
      let {
        checkedKeys
      } = treeCheckObj;

      if (checkedKeys.length === flattenTreeIdList.value.length) {
        checkAll.value = true;
      } else {
        checkAll.value = false;
      }
    }

    function flattenTreeData(treeList, targetList = []) {
      let list = [...targetList];
      treeList.forEach(item => {
        list.push(item.id);

        if (item.children && item.children.length) {
          let tmpList = flattenTreeData(item.children);
          list = list.concat(tmpList);
        }
      });
      return list;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择区域",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: filterText.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filterText.value = $event),
          placeholder: "查询地区"
        }, null, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_checkbox, {
          modelValue: checkAll.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => checkAll.value = $event),
          onChange: checkAllHandle
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }, 8, ["modelValue"])], 512), [[_vShow, !filterText.value]]), _createVNode(_component_el_scrollbar, {
          height: "300px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tree, {
            ref_key: "treeRef",
            ref: treeRef,
            data: treeData.value,
            "show-checkbox": "",
            "node-key": "id",
            "default-checked-keys": __props.defaultCheckedNodes,
            "filter-node-method": filterNode,
            props: {
              label: 'text',
              children: 'children'
            },
            onCheck: treeCheckHandle
          }, null, 8, ["data", "default-checked-keys"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};